export default __webpack_public_path__ + "static/media/Oliver_ParticleSmoke-31.ee82f96e.png";